<template>
  <div>
    <BreadCrumb PageTitle="Issues List" />
    <IssuesList />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import IssuesList from "../../components/Orders/IssuesList.vue";

export default defineComponent({
  name: "IssuesListPage",
  components: {
    BreadCrumb,
    IssuesList,
  },
});
</script>